/* eslint-disable max-len */
import EDC from '../../../shared/globals';
import { AnswerMark } from '../../../shared/mark-animation';
import BaseMinigamesMain from '../../../shared/base-minigames-scenes/base-main';
import store from '@/store/index';
import router from '@/router';

EDC.Games.CountItemsAndIncrement.Scenes.Main = function () {
  const gameId = router.currentRoute.params.id;
  BaseMinigamesMain.apply(this);

  this.gameConfig = store.getters['games/getGameById'](gameId).sets[0].config;
  this.gameData = EDC.Games.CountItemsAndIncrement.GameData;
  this.difficulty = 1;
  this.iteration = 0;
  this.instructions = [];
  this.items = [];
  this.choices = [];
};

EDC.Games.CountItemsAndIncrement.Scenes.Main.prototype = Object.create(BaseMinigamesMain.prototype);
EDC.Games.CountItemsAndIncrement.Scenes.Main.prototype.constructor = EDC.Games.CountItemsAndIncrement.Scenes.Main;

const CIAI = EDC.Games.CountItemsAndIncrement.Scenes.Main.prototype;

CIAI.create = function () {
  this.initialize();

  const title = this.add.sprite(250, 170, 'title');
  this.loadIteration();

  this.createBasicUI();
};

CIAI.loadIteration = function () {
  this.addInstructions();
  this.addItems();
  this.addChoices();
};

CIAI.addItems = function () {
  const itemsMin = this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsMin;
  const itemsMax = this.gameConfig.sets[this.difficulty].iterations[this.iteration].itemsMax;
  const itemsCount = itemsMin + Math.round(Math.random() * (itemsMax - itemsMin));
  let direction = 1;
  const items = [];
  for (let i = 0; i < 11; i++) {
    items.push(i);
  }
  this.shuffle(items);
  for (let i = 0; i < itemsCount; i++) {
    const item = this.add.sprite(0, 0, `fish-${  items[i % 11]}`);
    item.x = 500 + Math.floor(Math.random() * 1100);
    item.y = 65 + Math.floor(Math.random() * 450);
    item.direction = direction;
    direction *= -1;
    this.swimAnimation(item);
    this.items.push(item);
  }
};

CIAI.swimAnimation = function (item) {
  item.direction *= -1;
  if (item.direction > 0) {
    item.flipX = false;
  } else {
    item.flipX = true;
  }
  const swimmingTime = 8000 + Math.floor(Math.random() * 8000);
  const speed = 1600 / swimmingTime;
  const currentDistance = item.direction === 1 ? 1600 - item.x : item.x - 500;
  const neededTime = currentDistance / speed;
  const targetX = item.direction === 1 ? 1600 : 500;
  item.swimAnim = this.tweens.add({
    targets: item,
    x: targetX,
    duration: neededTime,
    ease: 'Sine.easeInOut',
    onComplete: this.swimAnimation.bind(this, item),
  });
};

CIAI.addChoices = function () {
  const { increment } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { operation } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let correctAnswer = this.items.length;
  if (operation === 'Add to') {
    correctAnswer += increment;
  } else {
    correctAnswer -= increment;
  }
  let choices = [];
  // generate 4 random and unique choices
  while (choices.length < 4) {
    const number = Math.floor(Math.random() * 9);
    if (choices.indexOf(number) === -1) {
      choices.push(number);
      choices[0] = correctAnswer;
    }
  }

  choices = this.shuffle(choices);
  for (let i = 0; i < choices.length; i++) {
    const choice = this.add.container(450 + i * 350, 880);
    const sprite = this.add.sprite(0, 0, `number-${choices[i]}`);
    choice.add(sprite);
    choice.setSize(sprite.displayWidth, sprite.displayHeight);
    if (choices[i] === correctAnswer) {
      choice.isCorrect = true;
    } else {
      choice.isCorrect = false;
    }
    this.shakeAnimation(choice);
    choice.setInteractive();
    const markAnim = new AnswerMark(this, choice).setScale(0.45);
    choice.setData('markAnim', markAnim);
    this.cursorManager.setDefaultDraggableEvents(choice);
    choice.on('pointerup', this.checkAnswer.bind(this, choice), this);
    this.choices.push(choice);
  }
};

CIAI.shakeAnimation = function (choice) {
  choice.shakeAnim = this.tweens.add({
    targets: choice,
    angle: choice.angle - 6,
    duration: 90,
    ease: 'Sine.easeInOut',
    repeat: 5,
    delay: 5000,
    yoyo: true,
    onComplete: this.shakeAnimation.bind(this, choice),
  });
};

CIAI.checkAnswer = function (choice) {
  if (choice.isCorrect) {
    this.playCorrect();
    choice.getData('markAnim').showMark(true, () => {});
    this.choices.map((x) => {
      x.disableInteractive();
      x.shakeAnim.stop();
      x.angle = 0;
      return true;
    });
    this.time.delayedCall(2000, this.nextIteration, [], this);
  } else {
    this.playWrong();
    choice.shakeAnim.stop();
    choice.angle = 0;
    choice.getData('markAnim').showMark(false, () => {});
    choice.first.setTint(0xff0000);
    choice.disableInteractive();
  }
};

CIAI.nextIteration = function () {
  this.choices.map((x) => {
    x.destroy();
    return true;
  });
  this.choices = [];
  this.items.map((x) => {
    x.destroy();
    return true;
  });
  this.items = [];
  this.instructions.map((x) => {
    x.destroy();
    return true;
  });
  this.instructions = [];
  this.iteration = this.iteration + 1;
  if (!this.gameConfig.sets[this.difficulty].iterations[this.iteration]) {
    this.showSummary();
  } else {
    this.loadIteration();
  }
};

CIAI.shuffle = function (a) {
  let j;
  let x;
  let i;
  for (i = a.length - 1; i > 0; i--) {
    j = Math.floor(Math.random() * (i + 1));
    x = a[i];
    a[i] = a[j];
    a[j] = x;
  }
  return a;
};

CIAI.addInstructions = function () {
  const { increment } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  const { operation } = this.gameConfig.sets[this.difficulty].iterations[this.iteration];
  let text;
  if (operation === 'Add to') {
    text = 'add    to';
  } else {
    text = 'substract    from';
  }
  let sentence = this.gameConfig.instructionsTxt.replace(`${operation}`, text);
  sentence = sentence.replace(`${increment}`, '');
  const instructions = this.make.text({
    x: 1000,
    y: 650,
    text: sentence,
    origin: { x: 0.5, y: 0.5 },
    style: {
      font: `65px ${this.gameConfig.font}`,
      wordWrap: { width: 850 },
      lineSpacing: 15,
    },
  });
  let number;
  if (text === 'add    to') {
    number = this.add.sprite(985, 680, `number-${increment}`).setScale(0.3);
  } else {
    number = this.add.sprite(1245, 655, `number-${increment}`).setScale(0.3);
  }

  this.instructions.push(instructions);
  this.instructions.push(number);
};

export default EDC.Games.CountItemsAndIncrement.Scenes.Main;
